<template>
  <div style="width: 100%; display: flex">
    <el-button size="small" @click="open">+ Импорт из excel</el-button>
    <el-dialog v-loading="loader" title="Прикрепить excel файл" :visible.sync="dialogObject">
      <div v-if="uploadValue === null">
        <el-upload
          style="margin-bottom: 20px"
          list-type="picture"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :http-request="onUpload"
          class="upload-demo"
          action="/"
          :show-file-list="false"
          drag
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Перетащите файл сюда или <br/><em>нажмите, чтобы загрузить</em></div>
        </el-upload>
        <div>
          <el-checkbox @input="changeRemove" v-model="isRemoveZone" v-if="type !== 'select'">Удалить по указанным
            зонам
          </el-checkbox>
        </div>
      </div>
      <el-progress v-else :percentage="uploadValue"></el-progress>
      <div style="display: flex; justify-content: center; margin: 15px auto 0 auto;">
        <a :href="dirUrl" v-if="!$store.state.project.plan || !$store.state.project.plan.id" target="_blank"
           style="margin-right: 4px">
          <el-button type="primary" @click="dialogObject = false">Выгрузка формат 1</el-button>
        </a>
        <a :href="dirUrl2" v-if="!$store.state.project.plan || !$store.state.project.plan.id" target="_blank"
           style="margin-left: 4px">
          <el-button type="primary" @click="dialogObject = false">Выгрузка формат 2</el-button>
        </a>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {apiUrl, isApiRuleIgnore} from "../../../plugins/firebase";

export default {
  name: 'ImportFromExcel',
  props: ['type', 'notActive'],
  data() {
    return {
      dialogObject: false,
      uploadValue: null,
      loader: false,
      blockConfirmation: false,
      isRemoveZone: false,
      step: 0,
    };
  },
  computed: {
    dirUrl() {

      let params = encodeURIComponent(`/onGenerateTemplateOptionsByInputs/${this.$store.state.project.id}`)

      if (this.type.includes('constructions')) {
        params = encodeURIComponent(`/onGenerateTemplateConstructionsByInputs/${this.$store.state.project.id}`)
      }

      if (this.type.includes('materials')) {
        params = encodeURIComponent(`/onGenerateTemplateMaterialsByInputs/${this.$store.state.project.id}`)
      }

      if (this.type.includes('multiple')) {
        params = encodeURIComponent(`/onGenerateTemplateMultiplesByInputs/${this.$store.state.project.id}`)
      }


      if(this.type.includes('nomenclature')) {

        if(this.notActive[2] && this.notActive[1]) {
          params = encodeURIComponent(`/onGenerateTemplateNomenclatureByConstructionsByInputs/${this.$store.state.project.id}`)

        }
        else if(this.notActive[2] || this.notActive[1]) {
          params = encodeURIComponent(`/onGenerateTemplateNomenclatureByMaterialsByInputs/${this.$store.state.project.id}`)

        }
        else {
          params = encodeURIComponent(`/onGenerateTemplateNomenclatureByMultiplesByInputs/${this.$store.state.project.id}`)

        }
      }

      if(isApiRuleIgnore) {
        return `${apiUrl}${params}&inputId=${this.$route.params.id}`;
      }
      return `${apiUrl}${params}&queryParams=inputId=${this.$route.params.id}`;
    },
    dirUrl2() {

      let params = encodeURIComponent(`/onGenerateTemplateOptionsByInputsV2/${this.$store.state.project.id}`)

      if (this.type.includes('constructions')) {
        params = encodeURIComponent(`/onGenerateTemplateConstructionsV2ByInputs/${this.$store.state.project.id}`)
      }

      if (this.type.includes('materials')) {
        params = encodeURIComponent(`/onGenerateTemplateMaterialsV2ByInputs/${this.$store.state.project.id}`)
      }

      if (this.type.includes('multiple')) {
        params = encodeURIComponent(`/onGenerateTemplateMultiplesV2ByInputs/${this.$store.state.project.id}`)
      }

      if(this.type.includes('nomenclature')) {

        if(this.notActive[2] && this.notActive[1]) {
          params = encodeURIComponent(`/onGenerateTemplateNomenclatureByConstructionsV2ByInputs/${this.$store.state.project.id}`)
        }
        else if(this.notActive[2] || this.notActive[1]) {
          params = encodeURIComponent(`/onGenerateTemplateNomenclatureByMaterialsV2ByInputs/${this.$store.state.project.id}`)
        } else {
          params = encodeURIComponent(`/nGenerateTemplateNomenclatureByMultiplesV2ByInputs/${this.$store.state.project.id}`)

        }
      }

      if(isApiRuleIgnore) {
        return `${apiUrl}${params}&inputId=${this.$route.params.id}`;

      }
      return `${apiUrl}${params}&queryParams=inputId=${this.$route.params.id}`;
    }
  },
  methods: {
    changeRemove() {
      if (this.isRemoveZone) {
        this.$notify({
          offset: 60,

          title: 'Внимание!',
          message: 'Будут удалены все существующие значения, по зонам указанным в файле загрузки',
          type: 'warning',
        });
      }
    },
    open() {
      this.dialogObject = true
      this.$emit('open')
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject('Error: ', error);
        };
      });
    },
    async onUpload(e) {
      const imageData = await this.getBase64(e.file);

      this.loader = true;

      let proxy = firebase.functions().httpsCallable('onParseOptionsByInputs');

      if (this.type.includes('constructions')) {
        proxy = firebase.functions().httpsCallable('onParseConstructionsByInputs');
      }

      if (this.type.includes('materials')) {
        proxy = firebase.functions().httpsCallable('onParseMaterialsByInputs');
      }

      if (this.type.includes('multiple')) {
        proxy = firebase.functions().httpsCallable('onParseMultiplesByInputs');
      }


      if(this.type.includes('nomenclature')) {

        if(this.notActive[2] && this.notActive[1]) {
          proxy = firebase.functions().httpsCallable('onParseConstructionsByNomenclatureByInputs');
        }
        else if(this.notActive[2] || this.notActive[1]) {
          proxy = firebase.functions().httpsCallable('onParseMaterialsByNomenclatureByInputs');
        } else {
          proxy = firebase.functions().httpsCallable('onParseConstructionsByNomenclatureByInputs');
        }
      }

      proxy(
        {
          options: imageData,
          inputId: this.$route.params.id,
          projectId: this.$store.state.project.id,
          isRemoveZone: this.isRemoveZone
        },
      ).then((response) => {
        this.$notify({
          title: 'Успешно!',
          message: 'Объекты загружены',
          type: 'success',
        });
        this.dialogObject = false;
        this.isRemoveZone = false;
        this.$emit('update')
      }).catch((error) => {
        this.$notify({
          title: 'Произошла ошибка',
          message: 'Файл загрузки не соответствует шаблону',
          type: 'error',
        });
      }).finally(() => {
        this.loader = false;
      });
    },
    save() {
      this.$emit('update');
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.isRemoveZone = false;

    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
  }
}

.el-upload--picture {
  display: flex;
  justify-content: center;
}

.el-loading-mask {
  position: fixed !important;
  background-color: rgba(255, 255, 255, .4) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/ImportFromExcel.vue